/**
 * Created by katarinababic on 17.11.22.
 */
import { makeAutoObservable } from 'mobx';
import { EarnEvents } from './EventProcessor';

export type EarnModelHistoryRequest = {
  event: EarnEvents;
  eventDateTime?: Date;
  requestId: string;
  data?: Record<string, any>;
};

export function createEarnModelHistoryRequest(json?: Partial<EarnModelHistoryRequest>): EarnModelHistoryRequest {
  return makeAutoObservable({
    event: json?.event ?? 'activity_logged',
    eventDateTime: json?.eventDateTime,
    requestId: json?.requestId ?? '',
    data: json?.data,
  });
}
